import {googleDetails} from "@/content";

export const GoogleServiceArea = () => {

    if(!googleDetails.googleServiceArea)return null;

    return (
        <div className="relative w-full max-w-4xl mx-auto overflow-hidden group">

            {/* Map */}
            <div className="relative w-full pb-[56.25%]">
                <iframe
                    src={googleDetails.googleServiceArea}
                    className="absolute top-0 left-0 w-full h-full"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </div>
    );
}
